import { Outlet } from "react-router-dom";
import "./dashboard-router.scss";
import {
  DesktopMenu,
  DashboardTopBar,
  MobileMenu,
  OfflineNotice,
} from "components";
import { useGetMe } from "hooks/auth";
import { useOfflineStatusCheck } from "utils";

const DashboardRouter = () => {
  const { data: authorizedUser } = useGetMe();
  const offlineStatus = useOfflineStatusCheck(authorizedUser?.role);

  return (
    <div className="dashboard">
      <DashboardTopBar user={authorizedUser} />
      <DesktopMenu user={authorizedUser} />
      <div className="dashboard-content__wrapper">
        <div className="dashboard-content">
          {offlineStatus.canShowDashboard ? (
            <Outlet />
          ) : (
            <OfflineNotice
              message={offlineStatus.message!}
              stats={offlineStatus.stats}
            />
          )}
        </div>
      </div>
      <MobileMenu user={authorizedUser} />
    </div>
  );
};

export default DashboardRouter;
